/**
 * Development-gated logger. Outputs to console only in non-production.
 * Replace raw console.error/console.warn with logger.error/logger.warn.
 */
const IS_DEV = process.env.NODE_ENV !== "production";

const noop = () => {};

const logger = {
  error: IS_DEV ? console.error.bind(console) : noop,
  warn: IS_DEV ? console.warn.bind(console) : noop,
  info: IS_DEV ? console.info.bind(console) : noop,
  debug: IS_DEV ? console.debug.bind(console) : noop,
};

export default logger;
